var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";

var Container = function Container(_ref) {
  var fluid = _ref.fluid,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["fluid", "className", "children"]);

  return React.createElement(
    "div",
    _extends({
      className: (fluid ? "container-fluid" : "container") + " " + (className || "")
    }, props),
    children
  );
};

Container.propTypes = {
  fluid: PropTypes.bool
};

Container.defaultProps = {
  fluid: false
};

export default Container;